import styled from 'styled-components';

export const Container = styled.button`
  width: 30px;
  height: 30px;
  background-color: transparent;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 0;
  margin: 0;
  border: none;
  outline: none;

  .grid,
  .list {
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;

    filter: ${({ selected, iconType }) => {
      if (iconType === 'latestNews')
        return selected
          ? 'invert(29%) sepia(52%) saturate(2970%) hue-rotate(187deg) brightness(91%) contrast(101%)'
          : 'none';
      return selected
        ? 'invert(29%) sepia(52%) saturate(2970%) hue-rotate(187deg) brightness(91%) contrast(101%)'
        : 'invert(69%) sepia(0%) saturate(106%) hue-rotate(169deg) brightness(90%) contrast(84%)';
    }};
  }

  &:hover {
    .grid,
    .list {
      filter: invert(29%) sepia(52%) saturate(2970%) hue-rotate(187deg) brightness(91%)
        contrast(101%);
    }
  }
`;
